"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PopoverCard = exports.Content = void 0;

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var Content = _styledComponents["default"].div.withConfig({
  displayName: "OverflowMenustyles__Content",
  componentId: "sc-5q8ct4-0"
})(["margin-left:-", ";margin-right:-", ";[role=\"menuitem\"]{", "}"], _tokens["default"].spaceLg, _tokens["default"].spaceLg, _stylers["default"].lineHeight(-1));

exports.Content = Content;
var PopoverCard = (0, _styledComponents["default"])(_popover["default"].Card).withConfig({
  displayName: "OverflowMenustyles__PopoverCard",
  componentId: "sc-5q8ct4-1"
})(function (_ref) {
  var maxHeight = _ref.maxHeight;
  return (0, _styledComponents.css)(["max-height:", ";overflow:auto;"], (0, _isNan["default"])(Number(maxHeight)) ? maxHeight : "".concat(maxHeight, "px"));
});
exports.PopoverCard = PopoverCard;
//# sourceMappingURL=OverflowMenu.styles.js.map